import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import logo from '../icons/logo.svg';
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import '../style/About.css';

const About = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const containerRef = useRef<HTMLDivElement | null>(null);
  const [hasShadow, setHasShadow] = useState(false);

  const handleEnterClick = () => {
    const userAgent = window.navigator.userAgent;
    const appIdentifiers = ['LinkedInApp', 'FBAV/', 'FBAN/', 'Instagram', 'FB_IAB', 'MESSENGER'];
    const isInAppBrowser = appIdentifiers.some(app => userAgent.includes(app));
    const isIOS = /iPhone|iPad|iPod/.test(navigator.userAgent);

    // URL to your login page
    const url = 'https://not-alone.app/login'; // Make sure this is the full URL
  
    if (isInAppBrowser && isIOS) {
      window.location.href = `x-safari://${url}`;
    } else {
      navigate(`/login`); // Use react-router's navigate for non-in-app browsers
    }
  };

  const handleScroll = () => {
    if (containerRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = containerRef.current;
      setHasShadow(scrollTop + clientHeight < scrollHeight);
    }
  };

  useEffect(() => {
    const currentContainer = containerRef.current;
    if (currentContainer) {
      currentContainer.addEventListener('scroll', handleScroll);
    }
    
    return () => {
      if (currentContainer) {
        currentContainer.removeEventListener('scroll', handleScroll);
      }
    };
  }, []);

  return (
    <div className="about">
      <img src={logo} alt="app Logo" className="about-logo" />
      <div 
        className={`about-container ${hasShadow ? 'shadow' : ''}`} 
        ref={containerRef}
      >       
        <h2 className="about-heading">{t('about.header')}</h2>
        <p>{t('about.p1')}</p>
        <p>{t('about.p2')}</p>
        <p>{t('about.p3')}</p>
        
        <h2 className="about-heading">{t('about.h2')}</h2>
        <p>{t('about.p4')}</p>
      </div>
      <Button className="about-button" onClick={handleEnterClick}>
        {t('about.enter')}
      </Button>   
    </div>
  );
};

export default About;
